import appConfig from '@/../config/config.json';

import Standard from "@/components/card/elements/Standard.vue";
import TwitterBox from "@/components/card/elements/TwitterBox.vue";
import QuestionAnswerBox from "@/components/card/elements/QuestionAnswerBox";
import NewsContainer from "@/components/card/elements/NewsContainer.vue";
import ArticleContainer from "@/components/card/elements/ArticleContainer.vue";
import KnowledgePanel from "@/components/card/elements/KnowledgePanel.vue";
import PositionedKnowledgePanel from "@/components/card/elements/PositionedKnowledgePanel.vue";
import VideoContainer from "@/components/card/elements/VideoContainer.vue";
import Sitelink from "@/components/card/elements/Sitelink.vue";
import Imagebox from "@/components/card/elements/Imagebox.vue";
import LatestFrom from "@/components/card/elements/LatestFrom.vue";
import Snippet from "@/components/card/elements/Snippet.vue";
import Faq from "@/components/card/elements/Faq.vue";
import YoutubeCarousel from "@/components/card/elements/YoutubeCarousel.vue";
import ProfilePanel from "@/components/card/elements/ProfilePanel.vue";
import Generic from "@/components/card/elements/Generic.vue";
import MiniSiteLinksResult from "@/components/card/elements/MiniSiteLinksResult";
import FeaturedResultsPanel from "@/components/card/elements/FeaturedResultsPanel";
import NewsFeedStandard from './components/card/elements/news-feed/NewsFeedStandard.vue';
import NewsFeedTopic from './components/card/elements/news-feed/NewsFeedTopic.vue';
import ShortVideosContainer from "@/components/card/elements/ShortVideosContainer";
import LatestPostsBox from "@/components/card/elements/LatestPostsBox";
import PerspectivesBox from "@/components/card/elements/PerspectivesBox";
import WhatPeopleAreSayingBox from "@/components/card/elements/WhatPeopleAreSayingBox";
import PostsOnXBox from "@/components/card/elements/PostsOnXBox";
import AiOverview from "@/components/card/elements/AiOverview";
import BooksBox from "@/components/card/elements/BooksBox";
import ScholarlyArticles from "@/components/card/elements/ScholarlyArticles";
import DiscussionsAndForumsBox from '@/components/card/elements/DiscussionsAndForumsBox.vue';
import SongsBox from "@/components/card/elements/SongsBox";
import AlbumsBox from "@/components/card/elements/AlbumsBox";
import EventsBox from "@/components/card/elements/EventsBox";

export const Result = Object.freeze({
  TYPE_LATEST_FROM: "latestfrombox",
  LEVEL_SECOND: "Second Level Result",
});

export const ToolsSelection = Object.freeze({
  DOWNLOAD_CSV: "DownloadCSV",
});

// TODO dynamically import everything in this folder https://stackoverflow.com/questions/54344164/how-to-import-all-vue-components-from-a-folder
export const ElementType = Object.freeze({
  Standard,
  TwitterBox,
  Generic,
  QuestionAnswerBox,
  NewsContainer,
  ArticleContainer,
  KnowledgePanel,
  PositionedKnowledgePanel,
  VideoContainer,
  Sitelink,
  Imagebox,
  LatestFrom,
  Snippet,
  Faq,
  YoutubeCarousel,
  ProfilePanel,
  MiniSiteLinksResult,
  FeaturedResultsPanel,
  NewsFeedStandard,
  NewsFeedTopic,
  ShortVideosContainer,
  LatestPostsBox,
  PerspectivesBox,
  WhatPeopleAreSayingBox,
  PostsOnXBox,
  AiOverview,
  BooksBox,
  ScholarlyArticles,
  DiscussionsAndForumsBox,
  SongsBox,
  AlbumsBox,
  EventsBox,
});

export const HighlightScopes = Object.freeze({
  SINGLE: "single",
  URL: "url",
  DOMAIN: "domain",
});

export const Views = Object.freeze({
  PARSING_TESTER: "parsing-tester",
});
export const ZoomSelectionOptions = Object.freeze({
  REGULAR_VIEW: "regular-view",
  MEDIUM_VIEW: "medium-view",
  SMALL_VIEW: "small-view",
});

export const IMPACT_QUERY_DATE_FORMAT = "dLLLyyyy";
export const LONG_DATE_FORMAT = "MMMM d, yyyy";
export const MEDIUM_DATE_FORMAT = "MMM d, yyyy";
export const SHORT_DATE_FORMAT = "MMM d";
export const API_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'+0000'"; // "2023-09-18T00:11:02+0000";

export const TIMELINE_NO_DATA_MSG = "No results available for this period";
export const TIMELINE_NO_DATA_FOR_CLIENT_MSG = "No data available for this client";

export const IRESULTS_AUTO_SAVE_INTERVAL = 30000;

export const DEFAULT_NEWS_IMAGE = require("@/assets/images/default_news_image.png");
export const DEFAULT_BOOK_IMAGE = require("@/assets/images/default_book_image.png");

// DM-6876 - the page an export came from, keyed by the `routeParams/view`
// getter. Every CSV name starts with this, so two pages can never hand back the
// same filename. Every view that calls downloadCSV is listed here: Timeline.vue
// (timeline / timelineNews; /timelinePAA also reports `timeline`),
// TimelineCompare.vue (timelineCompare) and TimelineKP.vue (kp).
export const CSV_TAB = Object.freeze({
  timeline: "Google_Results_Tab",
  timelineNews: "Google_News_Tab",
  timelineCompare: "Compare_Tab",
  kp: "Knowledge_Panels_Tab",
});

// DM-6876 - label for the Views dropdown selection, keyed by the `resultset`
// route param. This is not an allow-list: `resultset` also arrives off the URL
// and off the term-dropdown payload, so an unknown value falls through to
// itself rather than to `null`.
export const CSV_RESULT_SET = Object.freeze({
  geo: "Locations",
  peergroup: "Peers",
  history: "History",
  device: "Device",
  mobile_history: "Mobile_History",
  all: "All",
});

// DM-6876 - the four engine Views all set `resultset=history` (see
// ViewStates.model.js `engineOptions` and views/index.vue), differing only by
// `term.device`. Without this, a Bing export and a Google export of the same
// term and dates get the same filename, and the Bing one claims to be Google.
// Keys are the engine `ViewOptions` keys from ViewOptions.enum.js.
export const CSV_ENGINE = Object.freeze({
  pc: "Google_History",
  bingpc: "Bing_History",
  baidu: "Baidu_History",
  so: "SO_360_History",
});

export const RATING_COLORS = Object.freeze({
  POSITIVE: "#c2f0c2",
  NEUTRAL: "#d7d7d9",
  NEGATIVE: "#ffb2b2",
  UNMARKED: "#ffffff",
});

export const OWNERSHIP_COLORS = Object.freeze({
  OWNED: "#8fa9bc",
  NOT_ME: "#d4c6b8",
  NOT_OWNED: "#ffc299",
  UNMARKED: "#ffffff",
});

export const AUTHORITY_COLORS = Object.freeze({
  IAUTHORITY: "#dde0f1",
  EXPERT: "#bed1c5",
  SOCIAL: "#b6dced",
  CROWD: "#c8bac3",
  WIKIPEDIA: "#e5d8cd",
  UNMARKED: "#ffffff",
});

export const clientDetailsTable = Object.freeze({
  CLIENT_NAME_COL: 0,
  PRIMARY_LOCATION_COL: 1,
  ACCOUNT_MANAGER_COL: 2,
  STATUS_COL: 3,  
  ACTIONS_COL: 4,
});

export const sidebarItems = Object.freeze([
  {
    label: "Timeline",
    icon: "timeline",
    route: "/timeline",
  },
  {
    label: "News",
    icon: "timeline-news",
    route: "/timeline-news",
  },
  {
    label: "Knowledge Panels",
    icon: "knowledge-panels",
    route: "/timelineKP",
  },
  {
    separator: true,
    suOnly: true,
  },
  // {
  //   label: "Program Term Summary",
  //   icon: "program-term-summary",
  //   route: "/keywordSummary",
  //   suOnly: true,
  // },
    
  {
    label: "Manage Clients",
    icon: "client-management",
    route: "/clients",
    clientOwnerOnly: true,
    suOnly: true,
  },
  {
    label: "Manage Keywords",
    icon: "keyword-management",
    route: "/keywords",
  },
  // {
  //   label: "Manage Notifications",
  //   icon: "icons notifications-management",
  //   route: "/notificationsManagement",
  //   suOnly: true,
  // },
  {
    separator: true,
    clientOwnerOnly: true,
  },
  {
    label: "AIQ",
    icon: "ai-queries",
    route: appConfig.aisaas_url,
    newWindow: true,
    suOnly: true,
  },
  {
    label: "AIQ",
    icon: "ai-queries",
    route: "https://aiq.fiveblocks.com",
    newWindow: true,
    nonSuOnly: true,
  },
  {
    label: "Charts",
    icon: "charts-logo",
    route: "/charts",
  },
  // {
  //   label: "Legacy Timeline",
  //   icon: "timeline-legacy",
  //   route: "results",
  //   legacy: true,
  //   suOnly: true,
  // },
]);

